import type { FaireProductEntity } from "../../entity_types/product";

export const p_6xbgvaawaz: FaireProductEntity = {
  token: "p_6xbgvaawaz",
  type: "product",
  name: "Moroccan Cone Glassware Small - Blue",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/946f9685015ca5ccfa037355f79c0efca781a9bdacd6b716429c2dfeb1b93a30.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7606d09b2b65e68e028f90b887d728d7744849db3f6619184683985537446b9e.jpeg",
    "https://cdn.faire.com/fastly/e47fcc278ee31b9b4c8ce9313f9a1f3192cf0bb5fcbc2a78cc2c1d8e786e76ac.jpeg",
    "https://cdn.faire.com/fastly/84c22145cc75956a05179ff15283753c226e0c82bfbdeeae04480afea1c02438.jpeg",
    "https://cdn.faire.com/fastly/d2ec92ea284d082cc23f372188d8708c94a00f211fb0b5091ba05dfa89c19c5e.jpeg",
    "https://cdn.faire.com/fastly/c0478f5adae9348f1cd0134a09621ee1909d1f09af2bdc447e30da9555fb1f85.jpeg",
    "https://cdn.faire.com/fastly/8eadbcbaf75ea0a9147cc380129ffd099126b319dcf76f54a028893de2a1fe91.jpeg",
    "https://cdn.faire.com/fastly/a34b8b95f0a48e73301dbffdc785a329a63d496ae475559651afd8e886fcadbc.jpeg",
  ],
  priceDollars: 3.75,
  description:
    '**Packaged in sets of 6** - 24 single glasses in a master\nSee separate listings for each color option.\n\nThe sleek and simple design of these hand-blown cone shaped glasses are a testament to the style and skill of the artisans who make them. Used for all types of beverages or as little vases to decorate each table setting, you will enjoy the feel of them in your hand as you toast the joys of the day. \n\nOur Moroccan glassware sets come in four distinct shades of transparent glass (Clear, Amber, Blue & Green). The handblown construction is evident in the bubbles suspended in the glass itself, and the organic forms that the vessels take.\n\nMade from recycled beer and wine bottles, these sets are a second act for glass that would otherwise be sent to landfills. \n\nSmall Cone: bottom diameter 3", top diameter 2.5"  / 3.5" height. Capacity: 8 fl oz\n\nPackaged in sets of 6 in traditional Moroccan gift packaging.',
  tags: [],
  msrpDollars: 7.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:51.367Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
